import {
  RECEIVE_FARM_DETAILS,
  FAILURE_FARM_DETAILS,
  RECEIVE_FIELD,
} from '../constants/actionTypes';

export const initialState = {};

/**
 * Handles redux state for farm details
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function farmReducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_FARM_DETAILS: {
      const { growerName, name } = action.details;
      return {
        ...state,
        growerName,
        name,
      };
    }
    case FAILURE_FARM_DETAILS: {
      return {
        ...state,
        growerName: null,
        name: null,
      };
    }
    case RECEIVE_FIELD: {
      return {
        ...state,
        uuid: action.payload.farmId,
      };
    }
    default: {
      return state;
    }
  }
}

export default farmReducer;
